export enum IActionsTag {
  Button = 'button',
  Link = 'a'
}

export interface IActionsDropdown {
  icon?: (active?) => JSX.Element;
  onClick?: (id: string, payload? ) => void;
  loading?: boolean;
  tag?: IActionsTag;
  isShow?: (item) => boolean;
  name?: string;
  // Rendered as its own small button next to the actions menu instead of inside it.
  isPinned?: boolean;
  // Renders as a divider line instead of a button; no other field is needed on it.
  isDivider?: boolean;
}

export type DropdownFourProps = {
  actionsButtons?: IActionsDropdown[];
  item: any;
};
